// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderColumn":"styles_tableHeaderColumn__3XYUV","tableHeaderColumnInnerContainer":"styles_tableHeaderColumnInnerContainer__1Dq6y"};